export const user_action = "user_action/change";


export const userChange = (data, callback=null) => ({
    type: user_action,
    payload: {
        data,
        callback
    }
});


// WEBPACK FOOTER //
// ./src/libs/redux/actions/user.js